// extracted by mini-css-extract-plugin
module.exports = {"container-aboutSection":"AboutSection_container-aboutSection__PLayB"};